const section179Calculator = [
    {
        selector: '[data-section-179-calculator]',
        path: { filename: 'section179Calculator' },
    },
];

export { section179Calculator };
